<template>
    <v-card class="period-score  py-2 px-5" min-width="300px" style="font-family: Arial, sans-serif; background: #232323;">
        <div class="score-row">
            <div class="score-cell mr-5" />
            <span
                v-for="period in periods"
                :key="`period-${period}`"
                class="score-cell custom-teal-text font-weight-bold mr-5"
            >
                {{ period > 4 ? `OT${period - 4}` : `Q${period}` }}
            </span>
        </div>

        <div class="score-row">
            <v-avatar style="border-radius: 10px;" :size="$vuetify.breakpoint.mobile ? 40 : 70" color="white" class="mr-5">
                <v-img
                    :src="team1 && team1.logo ? `${assetsUrl}/${team1.logo}` : ''"
                    cover
                    @error="$event.target.style.visibility='hidden'"
                />
            </v-avatar>
            <span
                v-for="period in periods"
                :key="`team1-period-${period}`"
                class="score-cell mr-5"
                :style="{ fontWeight: 'bold', color: cellColor(periodScoresTeam1[period], periodScoresTeam2[period]) }"
            >
                {{ periodScoresTeam1[period] ?? '-' }}
            </span>
        </div>

        <div class="score-row mt-3">
            <v-avatar style="border-radius: 10px;" :size="$vuetify.breakpoint.mobile ? 40 : 70" color="white" class="mr-5">
                <v-img
                    :src="team2 && team2.logo ? `${assetsUrl}/${team2.logo}` : ''"
                    cover
                    @error="$event.target.style.visibility='hidden'"
                />
            </v-avatar>
            <span
                v-for="period in periods"
                :key="`team2-period-${period}`"
                class="score-cell mr-5"
                :style="{ fontWeight: 'bold', color: cellColor(periodScoresTeam2[period], periodScoresTeam1[period]) }"
            >
                {{ periodScoresTeam2[period] ?? '-' }}
            </span>
        </div>
    </v-card>
</template>

<script>
    export default {
        props: {
            periodScoresTeam1: {
                type: Object,
                default: () => ({ 1: '-', 2: '-', 3: '-', 4: '-' })
            },
            periodScoresTeam2: {
                type: Object,
                default: () => ({ 1: '-', 2: '-', 3: '-', 4: '-' })
            },
            team1: {
                type: Object,
                default: () => ({ name: 'Team 1' })
            },
            team2: {
                type: Object,
                default: () => ({ name: 'Team 2' })
            },
            backgroundColor: {
                type: String,
                default: 'white'
            }
        },
        data: () => ({
            assetsUrl: 'https://storage.googleapis.com'
        }),
        computed: {
            periods() {
                const normalize = obj =>
                    Object.keys(obj || {})
                        .map(k => Number(k))
                        .filter(n => Number.isFinite(n) && n > 0)
                        .sort((a, b) => a - b)

                const k1 = normalize(this.periodScoresTeam1)
                const k2 = normalize(this.periodScoresTeam2)

                if (!k1.length && !k2.length) return []

                if (k1.length < k2.length) return k1
                if (k2.length < k1.length) return k2

                // Same length: keep only common periods
                const set2 = new Set(k2)
                const inter = k1.filter(n => set2.has(n))
                return inter.length ? inter : k1
            }
        },
        methods: {
            cellColor(a, b) {
                const win = (Number(a) || 0) > (Number(b) || 0)
                return win ? '#00f3b3' : (this.backgroundColor === 'white' ? '#fff' : '#000')
            }
        }
    }
</script>

<style lang="css" scoped>
.period-score {
    /* 1.5x bigger */
    --cell-size: clamp(42px, 7.5vw, 72px);
    --font-size: clamp(18px, 2.7vw, 27px);
    --label-font-size: clamp(15px, 2.4vw, 24px);
    --gap: clamp(12px, 2.25vw, 30px);

    font-size: var(--font-size) !important;
}

.score-row {
    display: flex;
    align-items: center;
}

.score-cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--cell-size);
    height: var(--cell-size);
    font-size: var(--font-size);
}

/* Labels (Q/OT) a bit smaller */
.score-row .custom-teal-text {
    font-size: var(--label-font-size);
}

/* Team logos scale with cells */
.score-row img {
    width: var(--cell-size) !important;
    height: var(--cell-size) !important;
}

/* Responsive gap */
.period-score .mr-5 {
    margin-right: var(--gap) !important;
}
</style>
